import { ScuffedTesting } from "./test_framework";
import { ProcessedCacheTypes } from "../cluetrainer/ui/devutilitylayer/cachetools/ProcessedCacheTypes";
import { TileCoordinates } from "../lib/runescape/coordinates";
var testset = ScuffedTesting.testset;
var PrototypeInstance = ProcessedCacheTypes.PrototypeInstance;
var assertEquals = ScuffedTesting.assertEquals;
function assertEqualsTile(a, b, epsilon = 0.000001) {
    assertEquals(a.x, b.x, epsilon);
    assertEquals(a.y, b.y, epsilon);
    assertEquals(a.level, b.level, epsilon);
}
function assertInverse(a, b, test) {
    const trans = TileCoordinates.transform(test, a);
    const trans2 = TileCoordinates.transform(trans, b);
    assertEqualsTile(test, trans2);
}
function test_prototype() {
    const proto = {
        actions: [], id: undefined, name: "Test", raw: undefined, size: { x: 1, y: 2 },
    };
    const tests = [{
            size: { x: 1, y: 2 },
            instances: [{
                    position: { x: 5415, y: 2324, level: 0 }, rotation: 1, tests: [{
                            position: { y: 2, x: 0, level: 0 }, expected: { x: 5417, y: 2324, level: 0 },
                        }]
                }]
        }];
    for (const proto of tests) {
        const prot = {
            actions: [], id: undefined, name: "Test", raw: undefined, size: proto.size,
        };
        for (const instance of proto.instances) {
            const inst = new PrototypeInstance(prot, { id: undefined, position: instance.position, rotation: instance.rotation });
            const trans = inst.getTransform();
            const trans2 = inst.getInverseTransform();
            for (const test of instance.tests) {
                assertInverse(trans, trans2, test.position);
                assertEqualsTile(TileCoordinates.transform(test.position, trans), test.expected);
            }
        }
    }
}
export const test_prototype_transform = testset("Prototype Transform", test_prototype);
